<template>
    <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold b-right">End font of amortisation period</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">License – SMTC</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">2047</td>
                            <td class="end font ligest-gray">1,090,880</td>
                            <td class="end font">1,131,918</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">License – Atheer</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">2030</td>
                            <td class="end font ligest-gray">114,677</td>
                            <td class="end font">99,856</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">License – Pella</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">2021 to 2029</td>
                            <td class="end font ligest-gray">61,774</td>
                            <td class="end font">70,571</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Spectrum – SMTC </td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">2032 to 2034</td>
                            <td class="end font ligest-gray">131,799</td>
                            <td class="end font">92,714</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Others </td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">20,536</td>
                            <td class="end font">16,150</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold"> 1,419,666 </td>
                            <td class="end font white font-weight-bold">1,411,209</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold b-right">انتهاء فترة الإطفاء</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">ترخيص - زين السعودية</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">2047</td>
                            <td class="end font ligest-gray">1,090,880</td>
                            <td class="end font">1,131,918</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">ترخيص - أثير</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">2030</td>
                            <td class="end font ligest-gray">114,677</td>
                            <td class="end font">99,856</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">ترخيص - بيلا</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">2021 إلى 2029</td>
                            <td class="end font ligest-gray">61,774</td>
                            <td class="end font">70,571</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">الطيف الترددي - زين السعودية</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">2032 إلى 2034</td>
                            <td class="end font ligest-gray">131,799</td>
                            <td class="end font">92,714</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">أخرى</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">20,536</td>
                            <td class="end font">16,150</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold"> 1,419,666 </td>
                            <td class="end font white font-weight-bold">1,411,209</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>